import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';


import imagenotfound from '../../image/Image-not-found.png'
import { useState } from 'react';

import { useTablon } from '../../contexts/contextGeneral';

import { useNavigate } from 'react-router';
import { Button, Chip, Grid } from '@mui/material';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditSquareIcon from '@mui/icons-material/EditSquare';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { FcCamera } from "react-icons/fc";
import ModalPDF from '../PDF/ModalPDF';

function Orden(params) {
    const navigate = useNavigate();

    const { getOrden, orden } = useTablon()

    const handleOpenOrden = () => {
        getOrden(params.data.id)
        navigate("/ordenes/viewOrden")
    }

    const estatus = (x) => {
        const status = x
        if (status === null || status == 0) {
            return "noaplica"
        } else if (status == 1) {
            return "recibido"
        } else if (status == 2) {
            return "proceso"
        } else if (status == 3) {
            return "terminado"
        }
    }

    return (
        <>
            <Card>
                <div style={{ display: 'flex', justifyContent: "start", width: "100%", borderBottom: "solid 1px black" }}>
                    <div className="imageCar">
                        <CardMedia
                            component="img"
                            image={params.data.vehiculo.ruta ? "https://apiclimas.abdielaldana.com/" + params.data.vehiculo.ruta : imagenotfound}
                            alt={params.data.vehiculo.marca + " " + params.data.vehiculo.modelo}
                        />
                    </div>

                    <CardContent sx={{ width: "70% !important" }}>

                        <Typography variant="h6" style={{ width: "fit-content" }} >
                            {params.data.ot}
                        </Typography>


                        <Typography variant="body1" noWrap>
                            Placas: <b>{params.data.vehiculo.placas}</b>
                        </Typography>
                        <Typography variant="body1" noWrap>
                            Modelo: <b>{params.data.vehiculo.marca} {params.data.vehiculo.modelo}</b>
                        </Typography>
                        <Typography variant="body1" noWrap>
                            {params.data.trabajo}
                        </Typography>

                    </CardContent>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                    <Chip sx={{marginLeft: '10px'}} label={estatus(params.data.estatus)} size='small' color={estatus(params.data.estatus)} />
                    <CardActions disableSpacing sx={{ flexDirection: "row-reverse" }}>
                        <IconButton aria-label="Ver" size='large' color='primary' onClick={handleOpenOrden}>
                            <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton aria-label="Editar" size='large' color='secondary' onClick={() => navigate(`/ordenes/editar/${params.data.id}`)}>
                            <EditSquareIcon />
                        </IconButton>
                        <IconButton aria-label="Evidencias" size='large' color='epico' onClick={() => navigate(`/ordenes/imagenes/${params.data.id}`)}>
                            <FcCamera />
                        </IconButton>
                        <ModalPDF idOrder={params.data.id}>
                            <IconButton aria-label="PDF" size='large' color="success">
                                <SummarizeIcon />
                            </IconButton>
                        </ModalPDF>
                    </CardActions>
                </div>
            </Card>
        </>
    )
}

export default Orden